import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/models/user';


@Component({
  selector: 'app-navbar-backoffice',
  templateUrl: './navbar-backoffice.component.html',
  styleUrls: ['./navbar-backoffice.component.scss']
})
export class NavbarBackofficeComponent implements OnInit {

  userName: String = '';
  constructor( private router: Router ) { }

  ngOnInit(): void {

    this.userName = localStorage.getItem("google");
  }

  logout(){

    localStorage.removeItem('user');
    localStorage.removeItem('token');

    this.router.navigateByUrl('/login');
  }

  goPlatform(){

    this.router.navigateByUrl('/rep/companies');
  }

  goPreview(){}
}
